
import * as ipxRuntime$iP0jGFklZrFs8VES3_0e6hJpS83nf4I0vqT5OVZjTnM from '/home/runner/work/diegomarmol.com/diegomarmol.com/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$iP0jGFklZrFs8VES3_0e6hJpS83nf4I0vqT5OVZjTnM, defaults: {} }
}
        